/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Input,
  ConfigProvider,
  Image,
  Form,
  Divider,
  Typography,
  Row,
  Col,
} from "antd";
import {
  UserAddOutlined,
  //   UserOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import Timer from "otp-timer";
import PropTypes from "prop-types";
//components
import Logo from "../../assets/images/logo-main.png";
// import Logo from "../../assets/images/logo.png";
// import createLogo from "../../assets/images/sidebar-logo.png";
import "./auth.css";
import TinyColor from "@ctrl/tinycolor";
import { emailIsValid, phoneIsValid } from "./validations";
import SimpleReactValidator from "simple-react-validator";
import { isEmpty } from "lodash";
import { useHistory } from "react-router";
import api, { setAuthToken } from "../../helpers";
import { toast } from "react-toastify";
import useMedia from "use-media-antd-query";
import { MetaTags } from "react-meta-tags";

const { Title } = Typography;

const EmployeeLogin = (props) => {
  const media = useMedia();
  //Initial state values
  const [otpValue, setOtpValue] = useState("");
  const [locationPosition, setLocationPosition] = useState({
    latitude: "",
    longitude: "",
  });
  const [getOtp, setGetOtp] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [fieldsValidated, setFieldsValidated] = useState(false);
  const [userValue, setUserValue] = useState("");
  const [userId, setUserId] = useState("");

  //Initial state values end

  // employee login initial states
  const [anotherMethod, setAnotherMethod] = useState(false);
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [employeeValidations, setEmployeeValidations] = useState(false);

  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  useEffect(() => {
    if (anotherMethod == true) {
      navigator.geolocation.getCurrentPosition(function (position) {
        // console.log("Latitude is :", position.coords);
        setLocationPosition({
          ...locationPosition,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      });
    }
    if (navigator.geolocation) {
      navigator.permissions
        .query({ name: "geolocation" })
        .then(function (result) {
          // console.log(result);
        });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anotherMethod]);

  const history = useHistory();
  //validation change
  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setUserValue(current_value);
    if (!phoneIsValid(current_value) && !emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
      //   setFieldsValidated(true);
    } else {
      document.getElementById("error-panel").style.display = "none";
      if (phoneIsValid(current_value)) {
        const phoneNumberArr = [...current_value.matchAll(/\d{2}/g)].map(
          (x) => x["0"]
        );
        mainInput.value = phoneNumberArr.join(" ");
        setFieldsValidated(true);
      }
    }
  };

  //OnChange
  const onChange = (text) => {
    setOtpValue(text);
    // console.log("onChange:", text);
  };
  // const handleClick = (text) => {
  //   console.log("onClick:", text);
  // };
  const sharedProps = {
    onChange,
  };

  const [otpButtonDisabled, setOtpButtonDisabled] = useState(false);
  const [signInButtonDisabled, setSignInButtonDisabled] = useState(false);
  //signin functionality
  const otpValidations = () => {
    if (simpleValidator.current.allValid()) {
      setSignInButtonDisabled(true);
      setTimeout(() => {
        setSignInButtonDisabled(false);
      }, 4000);
      const user = {
        mobileNo: userValue,
        // otp: otpValue,
      };
      setLoader(true);
      api
        .post("/auth/users/login", user)
        .then((res) => {
          setUserId(res.data.userId);
          setGetOtp(true);
          setOtpSent(true);
          setError("");
          setTimeout(() => {
            setLoader(false);
          }, 1000);
          // document.getElementById("continueBtn").addEventListener("click", function() {
          //   // Show OTP fields
          //   document.getElementById("otpSection").style.display = "block";

          //   // Auto-focus on the first OTP field
          //   document.getElementById("otp1").focus();
          // });
          return res.data;
        })
        .catch((error) => {
          console.log(error, "error");
          const errorMsg =
            (error && error.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          setError(errorMsg);
          setGetOtp(false);
          setOtpSent(false);
          setLoader(true);
          setTimeout(() => {
            setLoader(false);
          }, 2000);
          Promise.reject(error);
        });
      // history.push("/user-details");
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  const signIn = () => {
    if (!isEmpty(otpValue) && otpValue.length == 6) {
      setOtpButtonDisabled(true);
      setTimeout(() => {
        setOtpButtonDisabled(false);
      }, 4000);
      const user = {
        userId: userId,
        // "otp": "228100",
        latitude: locationPosition.latitude,
        longitude: locationPosition.longitude,
        // email: userValue,
        otp: otpValue,
      };
      api
        .post("/auth/users/otpverification", user)
        .then((res) => {
          // setUserId(res.data);
          setAuthToken(res.data.token);
          setError("");
          setLoader(true);
          setTimeout(() => {
            setLoader(false);
          }, 2000);
          localStorage.setItem("authToken", res.data.token);
          localStorage.setItem("user", res.data);
          localStorage.setItem("authData", JSON.stringify(res.data));
          localStorage.setItem("welcomeNotification", true);
          history.push({ pathname: "/dashboard" });
          return res.data;
        })
        .catch((error) => {
          console.log(error, "error");
          const errorMsg =
            (error && error.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          setError(errorMsg);
          setLoader(true);
          setTimeout(() => {
            setLoader(false);
          }, 2000);
          Promise.reject(error);
        });
    } else {
      toast.error("Enter the otp to verify the user");
    }
  };

  //signin functionality
  const employeeLogin = () => {
    if (!isEmpty(userName) && !isEmpty(password)) {
      setSignInButtonDisabled(true);
      setTimeout(() => {
        setSignInButtonDisabled(false);
      }, 4000);
      const user = {
        userName: userName,
        password: password,
        latitude: locationPosition.latitude,
        longitude: locationPosition.longitude,
      };
      api
        .post("/auth/users/login", user)
        .then((res) => {
          setUserId(res.data.userId);
          localStorage.setItem("authToken", res.data.token);
          localStorage.setItem("user", res.data);
          localStorage.setItem("authData", JSON.stringify(res.data));
          setLoader(true);
          setEmployeeValidations(false);
          setError("");
          setTimeout(() => {
            setLoader(false);
            if (res.data.isotpTwowayAuth == false) {
              history.push("/dashboard");
            } else {
              // setFieldsValidated(true);
              setGetOtp(true);
              setOtpSent(true);
              setUserId(res.data.userId);
            }
          }, 2000);
          return res.data;
        })
        .catch((error) => {
          console.log(error, "error");
          const errorMsg =
            (error && error.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          setError(errorMsg);
          setLoader(true);
          setTimeout(() => {
            setLoader(false);
          }, 2000);
          Promise.reject(error);
        });
      // history.push("/user-details");
    } else {
      setEmployeeValidations(true);
    }
  };

  //otp condition false
  useEffect(() => {
    if (getOtp === true) {
      setTimeout(() => {
        setGetOtp(false);
        setOtpSent(false);
      }, 45000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getOtp]);

  const otpInputRef = useRef(null);

  useEffect(() => {
    if ((getOtp && fieldsValidated) || (getOtp && otpSent)) {
      setTimeout(() => {
        otpInputRef.current?.focus(); // Ensure focus on the OTP input field
      }, 100);
    }
  }, [getOtp, fieldsValidated, otpSent]);

  //button styles

  const getHoverColors = (colors) =>
    colors.map((color) => new TinyColor(color).lighten(5).toString());
  const getActiveColors = (colors) =>
    colors.map((color) => new TinyColor(color).darken(5).toString());

  const colors1 = ["#6253E1", "#04BEFE"];

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Employee Login | Mbook</title>
        </MetaTags>
      </div>
      <Row className="employee-login-main-card">
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            media === "xs"
              ? "employee-login-image flex justify-center"
              : "employee-login-image lg:pr-0 lg:pl-0 md:pr-0 md:pl-0 sm:pr-4 sm:pl-4 pl-4 pr-4 flex md:justify-end lg:justify-end justify-center"
          }
        >
          {/* <div className="xs:hidden sm:hidden md:inline">
            <h1
              style={{
                textTransform: "capitalize",
              }}
            >
              Mbook
            </h1>
          </div> */}
          {/* <div className="employee-login-image-content">
            <h1 className="employee-login-image-content-text text-start leading-none font-[700]">
              Welcome to <br /> our community
            </h1>
            <p className=" text-[18px] text-start leading-tight text-[lightgray] mt-3">
              Personalised, update daily and beautifully presented. <br />{" "}
              Create account to find your dream new home and get full <br />{" "}
              access to platform's functionality.
            </p>
          </div> */}
          <Col
            md={12}
            lg={8}
            sm={20}
            xs={20}
            className="employee-login-form-main pt-3"
          >
            <div
              className={
                media === "xs"
                  ? "employee-login-form-grid pt-[50px] pr-[25px] pl-[25px] rounded-lg "
                  : "employee-login-form-grid pt-[50px] pr-[50px] pl-[50px] sm:rounded-lg rounded-lg md:rounded-tr-none md:rounded-br-none md:rounded-tl-lg md:rounded-bl-lg"
              }
            >
              <div className="mb-2 text-start">
                <Image src={Logo} preview={false} width={150} />
              </div>
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="mb-2 text-[black] text-start"
              >
                <h1 className="flex text-[#768ea7]">
                  Welcome to{" "}
                  <p className="pl-1 font-semibold text-[#768ea7]">Mbook</p>
                </h1>
              </div>
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="mb-2 text-[black] text-start"
              >
                <h1
                  className={
                    media === "xs"
                      ? "flex text-[black] text-[16px] font-semibold"
                      : "flex text-[black] text-[20px] font-semibold"
                  }
                >
                  Login with your
                  {anotherMethod
                    ? " user name and password"
                    : " email or phone number"}
                  {/* Get started with your email or phone number */}
                </h1>
              </div>
              <Typography className="mt-4 auth-login-label mb-1 text-[red] text-[13px] text-center">
                {error && error ? error : ""}
              </Typography>
              {anotherMethod ? (
                <Form.Item name="userValue" className="mt-2 mb-1">
                  <Input
                    className="p-1.5 auth-login-label"
                    id="main-input"
                    name="userName"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    placeholder="Enter your user name"
                  />
                  <p className="flex text-start text-[red] mt-2 mb-2">
                    {employeeValidations == true && isEmpty(userName)
                      ? "user name field is required"
                      : ""}
                  </p>
                </Form.Item>
              ) : (
                <Form.Item name="userValue" className="mt-2 mb-1">
                  <Input
                    className="p-1.5"
                    id="main-input"
                    name="userValue"
                    maxLength={fieldsValidated === true ? 12 : 30}
                    value={userValue}
                    style={{
                      fontFamily: "Poppins",
                    }}
                    placeholder="Enter your email or phone number"
                    onChange={validationChange}
                  />
                  <p className="flex text-start text-[red] mt-2 mb-2">
                    {/* {!userValue ? (
                    <ExclamationCircleOutlined className="mr-2" />
                  ) : (
                    ""
                  )} */}
                    {simpleValidator.current.message(
                      "email or mobile",
                      userValue,
                      "required"
                    )}
                  </p>
                </Form.Item>
              )}
              {anotherMethod ? (
                <Form.Item name="userValue" className="mt-2 mb-1">
                  {/* <Typography>Password</Typography> */}
                  <Input.Password
                    className="p-1.5"
                    id="main-input"
                    name="password"
                    value={password}
                    style={{
                      fontFamily: "Poppins",
                    }}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    // onChange={validationChange}
                  />
                  <p className="flex text-start text-[red] mt-2 mb-2">
                    {employeeValidations == true && isEmpty(password)
                      ? "password field is required"
                      : ""}
                  </p>
                </Form.Item>
              ) : (
                ""
              )}

              <div
                id="error-panel"
                style={{
                  display: "none",
                  marginTop: "-20px",
                  marginBottom: "10px",
                }}
              >
                {isEmpty(userValue) ? (
                  ""
                ) : (
                  <p className="text-start text-[13px] text-[#ff0000]">
                    The email or mobile field is not valid
                  </p>
                )}
              </div>

              {/* <div className="text-center mt-[40px] w-[100%]">
              <Button
                type="dashed"
                className="w-[100%] p-5 hover:none"
                disabled={
                  // fieldsValidated
                  //   ? true
                  isEmpty(error)
                    ? false
                    : (fieldsValidated && getOtp) || otpSent === true
                    ? true
                    : false
                }
                onClick={() => otpValidations()}
              >
                Get OTP
              </Button>
            </div> */}

              {(getOtp && fieldsValidated) || (getOtp && otpSent) ? (
                <div className="mt-2">
                  <Timer
                    textColor={"#000000"}
                    seconds={45}
                    minutes={0}
                    // buttonColor={'red'}
                    background={"none"}
                    // text={`OTP sent to you via sms or e-mail`}
                    text={`Entered OTP sent to you mobile or email - `}
                    // resend={handleClick}
                  />
                  {/* <p
                    className="text-[black] text-[14px] underline"
                    onClick={handleClick}
                  >
                    Resend Otp
                  </p> */}
                </div>
              ) : (
                ""
              )}
              {(fieldsValidated && otpSent) || otpSent ? (
                <p
                  className="cursor-pointer text-[black] text-[14px] underline"
                  onClick={() => otpValidations()}
                >
                  Resend OTP
                </p>
              ) : (
                ""
              )}
              {(getOtp && fieldsValidated) || (getOtp && otpSent) ? (
                <div className="ml-2 w-[100%]">
                  <div className="mt-5">
                    <Title level={6}></Title>
                    <Input.OTP
                      ref={otpInputRef}
                      formatter={(str) => str.toUpperCase()}
                      {...sharedProps}
                    />
                  </div>{" "}
                </div>
              ) : (
                ""
              )}
              {getOtp && otpSent ? (
                <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        colorPrimary: `linear-gradient(116deg,  ${colors1.join(
                          ", "
                        )})`,
                        colorPrimaryHover: `linear-gradient(116deg, ${getHoverColors(
                          colors1
                        ).join(", ")})`,
                        colorPrimaryActive: `linear-gradient(116deg, ${getActiveColors(
                          colors1
                        ).join(", ")})`,
                        lineWidth: 0,
                      },
                    },
                  }}
                >
                  <Button
                    className={
                      fieldsValidated === true || otpSent === true
                        ? "auth-login-label text-[13px] mt-[15px] p-4 w-[100%]"
                        : "auth-login-label text-[13px] pointer-events-none opacity-25 mt-[15px] p-4 w-[100%]"
                    }
                    type="primary"
                    // htmlType="submit"

                    disabled={otpButtonDisabled ? true : false}
                    onClick={signIn}
                    icon={<UserAddOutlined />}
                  >
                    {loader ? "Loading..." : "Verify"}
                  </Button>
                </ConfigProvider>
              ) : (
                <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        colorPrimary: `linear-gradient(116deg,  ${colors1.join(
                          ", "
                        )})`,
                        colorPrimaryHover: `linear-gradient(116deg, ${getHoverColors(
                          colors1
                        ).join(", ")})`,
                        colorPrimaryActive: `linear-gradient(116deg, ${getActiveColors(
                          colors1
                        ).join(", ")})`,
                        lineWidth: 0,
                      },
                    },
                  }}
                >
                  <Button
                    className={
                      fieldsValidated === true || anotherMethod
                        ? "auth-login-label text-[13px] mt-[15px] p-4 w-[100%]"
                        : "auth-login-label text-[13px] pointer-events-none opacity-25 mt-[15px] p-4 w-[100%]"
                    }
                    type="primary"
                    // htmlType="submit"
                    style={{
                      fontFamily: "Poppins",
                    }}
                    disabled={signInButtonDisabled ? true : false}
                    onClick={anotherMethod ? employeeLogin : otpValidations}
                    // icon={<UserAddOutlined />}
                  >
                    {loader ? "Loading..." : "Continue"}
                  </Button>
                </ConfigProvider>
              )}
              <Divider style={{ fontWeight: 600, marginTop: "20px" }}>
                {" "}
                <SafetyCertificateOutlined /> 100% secure
              </Divider>
              {/* <div className="flex justify-center mt-[40px] w-[100%]">
                <Button
                  type="dashed"
                  className="w-[60%] p-3 hover:none"
                  onClick={() => history.push("/login")}
                >
                  Login
                </Button>
              </div> */}
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                className="mb-2 mt-[40px] text-[12px] text-[black] flex justify-center"
              >
                <h1
                  className={
                    media === "xs"
                      ? "flex flex-col text-[#768ea7]"
                      : "flex text-[#768ea7]"
                  }
                >
                  Want to change your login method?
                  <p
                    onClick={() => setAnotherMethod(!anotherMethod)}
                    className="cursor-pointer pl-1 font-semibold text-[13px] text-[#1677ff]"
                  >
                    {anotherMethod
                      ? "Use default method"
                      : "Use another method"}
                  </p>
                </h1>
              </div>
            </div>
          </Col>
        </Col>
      </Row>
    </React.Fragment>
  );
};

EmployeeLogin.propTypes = {
  onSignin: PropTypes.any,
};

export default EmployeeLogin;
